import { render, staticRenderFns } from "./BSFindSnelstartModal.vue?vue&type=template&id=da762e30"
import script from "./BSFindSnelstartModal.vue?vue&type=script&lang=js"
export * from "./BSFindSnelstartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports